import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Website from './Website';
import GamingLoginPage from './LoginPage';
import Dashboard from './Dashboard';
const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  return isAuthenticated ? children : <Navigate to="/admin" />;
};

const App = () => {
  const handleLogin = (userData) => {
    // Store user data in localStorage
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('username', userData.username);
    localStorage.setItem('userId', userData.id);

    // Navigate to dashboard after successful login
    window.location.href = '/dashboard';
  };

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Website />} />
        <Route path="/home" element={<Website />} />
        <Route path="/admin" element={<GamingLoginPage onLogin={handleLogin} />} />

        {/* Protected Routes */}
        <Route 
          path="/dashboard" 
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } 
        />
         <Route 
          path="/dashboard/subscribers" 
          element={
            <PrivateRoute>
              <Dashboard defaultTab="subscribers" />
            </PrivateRoute>
          } 
        />
        {/* Catch all unknown routes and redirect to home */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default App;